import { render, staticRenderFns } from "./GoogleSso.vue?vue&type=template&id=04b53d94&"
import script from "./GoogleSso.vue?vue&type=script&lang=js&"
export * from "./GoogleSso.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSso.vue?vue&type=style&index=0&id=04b53d94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports